import { render } from "./ModalAsignar.vue?vue&type=template&id=1aa173ec&scoped=true"
import script from "./ModalAsignar.vue?vue&type=script&lang=js"
export * from "./ModalAsignar.vue?vue&type=script&lang=js"

import "./ModalAsignar.vue?vue&type=style&index=0&id=1aa173ec&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa173ec"]])

export default __exports__